'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'I18n';
import UIBox from 'UIComponents/layout/UIBox';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import UIIconRating from 'UIComponents/input/UIIconRating';
import ReviewerInfo from './ReviewerInfo';

var ReviewCard = function ReviewCard(_ref) {
  var company = _ref.company,
      rating = _ref.rating,
      reviewDate = _ref.reviewDate,
      reviewText = _ref.reviewText,
      userAvatarUrl = _ref.userAvatarUrl,
      userFullName = _ref.userFullName;
  return React.createElement(UICardWrapper, {
    compact: true
  }, React.createElement(UICardSection, null, React.createElement(UIFlex, {
    justify: "between"
  }, React.createElement(UIBox, null, React.createElement(Small, {
    className: "secondary-text"
  }, I18n.moment.utc(reviewDate).format('LL'))), React.createElement(UIBox, null, React.createElement(UIIconRating, {
    disabled: true,
    size: "xxs",
    value: rating
  })))), React.createElement(UICardSection, null, React.createElement("p", null, reviewText)), React.createElement(UICardSection, null, React.createElement(ReviewerInfo, {
    company: company,
    userAvatarUrl: userAvatarUrl,
    userFullName: userFullName
  })));
};

ReviewCard.propTypes = {
  company: PropTypes.string,
  rating: PropTypes.number.isRequired,
  reviewDate: PropTypes.number.isRequired,
  reviewText: PropTypes.string.isRequired,
  userAvatarUrl: PropTypes.string.isRequired,
  userFullName: PropTypes.string.isRequired
};
export default ReviewCard;